"use client";

import { SuperLink as Link } from "@/components/common/super-link";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const CardTools = ({
  title,
  link,
  categorySvgContent,
  subtitle,
  categoryName,
  categoryLink,
  onClick = () => {},
  onClickCategory = () => {},
  showCategory = true,
}: {
  title: string;
  subtitle?: string;
  link: string;
  categorySvgContent?: string;
  categoryName?: string;
  categoryLink?: string;
  onClick?: () => void;
  onClickCategory?: () => void;
  showCategory?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={
        "group relative grid h-full gap-0 rounded-lg border-[1px] bg-white p-4"
      }
    >
      <div
        className={cn(
          "absolute inset-0 z-0 bg-gradient-to-br opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100",
          "from-remedium-blue/1 to-remedium-blue/5",
        )}
      ></div>
      {categoryName && showCategory && (
        <Link
          href={categoryLink as string}
          onClick={onClickCategory}
          className={"relative z-10 contents"}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: categorySvgContent as string,
            }}
            className={
              "relative z-10 mb-4 inline-flex h-[24px] w-[24px] items-center justify-center rounded-sm [&_path]:[stroke:black] [&_svg]:w-[24px]"
            }
          />
        </Link>
      )}

      <a
        href={link}
        className={"absolute-link hover:[&+h3]:text-remedium-blue z-1"}
      />

      <p
        onClick={onClick}
        className="group-hover:text-remedium-blue flex items-start gap-2 text-base leading-normal font-semibold text-zinc-950 transition-all"
      >
        {title}
      </p>
      {subtitle && (
        <p className="mt-1 text-sm leading-tight text-zinc-500">{subtitle}</p>
      )}

      {categoryName && showCategory && (
        <>
          <div className={"mt-3"}></div>
          <Link
            href={categoryLink as string}
            onClick={onClickCategory}
            className={"relative z-10"}
          >
            <Badge
              variant={"brandSoft"}
              className={
                "rounded-full px-2.5 font-semibold transition-all hover:scale-102 active:scale-98"
              }
            >
              {categoryName}
            </Badge>
          </Link>
        </>
      )}
    </div>
  );
};
